<template>
  <!-- Grid Usuários -->
  <div class="users">
    <div class="header form-inline mb-3">
      <div class="form-inline">
        <h4 class="mr-5">Controle de Usuários</h4>
        <button class="btn btn-primary ml-2" @click="newUser()">Novo Usuário</button>
      </div>
      <div>
        <input class="form-control mr-2" type="text" placeholder="Informe o usuário" v-model="search">
        <button class="btn btn-outline-primary" type="button" @click="getUsers()">Localizar</button>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <table class="table">
          <thead class="thead">
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Email</th>
              <th scope="col" class="text-center">Adminstrador</th>
              <th scope="col">Data Última Impressão</th>
              <th scope="col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in users" :key="index">
              <td>{{ user.name }}</td>
              <td>{{ user.email }}</td>
              <td class="text-center">{{ user.admin ? 'Sim' : 'Não' }}</td>
              <td>{{ formatLastPrintDate(user.lastPrintDate) }}</td>
              <td>
                <div class="btn-group">
                  <button class="btn btn-outline-secondary" @click="updateUser(user)">
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                  <button class="btn btn-outline-danger" @click="deleteUser(user.id)">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Form Modal -->
    <div class="user">
      <div class="userModal" :style="{ display: showModal ? 'block' : 'none' }">
        <form>
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Usuário</h5>
                <span class="close" @click="closeModal()">&times;</span>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="form-group col-8">
                    <label>Nome</label>
                    <input type="text" class="form-control" v-model="user.name"/>
                  </div>
                  <div class="form-group col-4">
                    <div class="form-group form-check">
                      <input type="checkbox" class="form-check-input" v-model="user.admin">
                      <label class="form-check-label">Administrador</label>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="!user.id">
                  <div class="form-group col-8">
                    <label>Email</label>
                    <input type="email" class="form-control" v-model="user.email"/>
                  </div>
                </div>
                <div class="row" v-if="!user.id">
                  <div class="form-group col-4">
                    <label>Senha</label>
                    <input type="password" class="form-control" v-model="password"/>
                  </div>
                  <div class="form-group col-4">
                    <label>Confirme Senha</label>
                    <input type="password" class="form-control" v-model="confirmPassword"/>
                  </div>
                </div>
              </div>
              <div class="modal-footer mt-3">
                <button class="btn btn-secondary" @click.prevent="cancel()">
                  Cancelar
                </button>
                <button class="btn btn-primary" @click.prevent="saveUser()">
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Users',
  data: () => ({
    users: [],
    search: '',
    user: {
      id: '',
      name: '',
      email: '',
      admin: ''
    },
    showModal: false,
    password: '',
    confirmPassword: ''
  }),
  methods: {
    getUsers () {
      this.$firebase.database().ref('users')
        .on('value', (data) => {
          const values = data.val()
          if (values !== null) {
            let users = Object.keys(values).map((items) => values[items])

            // Se há texto de busca, filtrar por nome ou email contendo o texto
            if (this.search && this.search.trim() !== '') {
              const searchTerm = this.search.toLowerCase().trim()
              users = users.filter(user => {
                const name = (user.name || '').toLowerCase()
                const email = (user.email || '').toLowerCase()
                return name.includes(searchTerm) || email.includes(searchTerm)
              })
            }

            this.users = users.sort(this.order)
          } else this.users = []
        })
      this.search = ''
    },
    order (a, b) {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    },
    formatLastPrintDate (timestamp) {
      if (!timestamp) {
        return 'Nunca'
      }
      const date = new Date(timestamp)
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    newUser () {
      this.showModal = true
    },
    updateUser (object) {
      this.user = object
      this.showModal = true
    },
    deleteUser (id) {
      const resultado = confirm('Deseja excluir o usuário?')
      if (resultado === true) {
        const ref = this.$firebase.database().ref(`users/${id}`)

        ref.remove().then(() => {
          this.$root.$emit('Notification::show', {
            message: 'Usuário removido com sucesso.',
            type: 'success'
          })
        }).catch(() => {
          this.$root.$emit('Notification::show', {
            message: 'Não foi possivel exlcuir o usuário, tente novamente.',
            type: 'danger'
          })
        })
      }
    },
    async saveUser () {
      if (this.validation()) {
        this.$root.$emit('Spinner::show')

        try {
          this.ref = this.$firebase.database().ref('users')

          if (!this.user.id) {
            await this.$firebase.auth()
              .createUserWithEmailAndPassword(this.user.email, this.password)
              .then((newUser) => {
                this.user.id = newUser.user.uid
              })
          }
          const payload = {
            ...this.user
          }

          this.ref.child(this.user.id).set(payload)

          this.closeModal()
        } catch (error) {
          let message = ''

          switch (error.code) {
            case 'auth/email-already-in-use':
              message = 'O endereço de e-mail já está sendo usado por outro usuário.'
              break
            default:
              message = 'Não foi possivel inserir o usuário, tente novamente.'
          }

          this.$root.$emit('Notification::show', {
            message,
            type: 'danger'
          })

          console.log(error)
        }

        this.$root.$emit('Spinner::hide')
      }
    },
    cancel () {
      this.closeModal()
      this.getUsers()
    },
    closeModal () {
      this.password = ''
      this.confirmPassword = ''
      this.user = {}
      this.showModal = false
    },
    validation () {
      if (!this.user.name) {
        this.$root.$emit('Notification::show', {
          message: 'Favor informar o nome.',
          type: 'warning'
        })
      } else if (!this.user.email) {
        this.$root.$emit('Notification::show', {
          message: 'Favor informar o email.',
          type: 'warning'
        })
      } else if ((this.confirmPassword !== this.password) && (!this.user.id)) {
        this.$root.$emit('Notification::show', {
          message: 'O campo senha e o campo confirmação de senha precisam ser iguais.',
          type: 'warning'
        })
      } else if ((this.password.length < 6) && (!this.user.id)) {
        this.$root.$emit('Notification::show', {
          message: 'Favor informa no minimo 6 caracteres para o campo senha.',
          type: 'warning'
        })
      } else {
        return true
      }
    }
  },
  created () {
    this.getUsers()
  }
}
</script>

<style lang="scss" scoped>
.users {
  padding: 40px 60px;
  height: 100%;
  .header {
    display: flex;
    justify-content: space-between;
  }
}
.user {
  .userModal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1000;
    form {
      .close {
        &:hover {
          color: #000;
          cursor: pointer;
        }
      }
      .form-check {
        margin-top: 20px;
        padding-top: 10px;
      }
    }
  }
}
</style>
